(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mds-metadata-quality-report-ui-main"] = factory();
	else
		root["mds-metadata-quality-report-ui-main"] = factory();
})(window, function() {
return 